import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogTitle, DialogContent, Typography, Box,
} from '@material-ui/core';
import { object, string, ref } from 'yup';
import { FormattedMessage } from 'react-intl';
import MyForm from '../../form/MyForm';
import { MY_FORM_FIELD_TEXT } from '../../form/form-constants';
import { seedAppIcons } from '../../icon/seed-icons';

const nameOldPassword = 'oldPassword';
const namePassword = 'password';
const namePasswordConfirmation = 'passwordConfirmation';

const withPasswordFields = [
  {
    name: nameOldPassword,
    type: MY_FORM_FIELD_TEXT,
    labelId: 'seed.firebase.authentication.form.oldPassword',
    inputProps: {
      type: 'password',
    },
  },
  {
    name: namePassword,
    type: MY_FORM_FIELD_TEXT,
    labelId: 'seed.firebase.authentication.form.newPassword',
    inputProps: {
      type: 'password',
    },
  },
  {
    name: namePasswordConfirmation,
    type: MY_FORM_FIELD_TEXT,
    labelId: 'seed.firebase.authentication.form.newPasswordConfirmation',
    inputProps: {
      type: 'password',
    },
  },
];

const fields = [
  {
    name: namePassword,
    type: MY_FORM_FIELD_TEXT,
    labelId: 'seed.firebase.authentication.form.newPassword',
    inputProps: {
      type: 'password',
    },
  },
  {
    name: namePasswordConfirmation,
    type: MY_FORM_FIELD_TEXT,
    labelId: 'seed.firebase.authentication.form.newPasswordConfirmation',
    inputProps: {
      type: 'password',
    },
  },
];

const withPasswordValidationSchema = object({
  [nameOldPassword]: string()
    .required('seed.firebase.authentication.form.oldPassword.required'),
  [namePassword]: string()
    .min(8, 'seed.firebase.authentication.form.newPassword.min')
    .required('seed.firebase.authentication.form.newPassword.required'),
  [namePasswordConfirmation]: string('')
    .oneOf([ref(`${namePassword}`), null], 'seed.firebase.authentication.form.newPasswordConfirmation.match')
    .required('seed.firebase.authentication.form.newPasswordConfirmation.required'),
});

const validationSchema = object({
  [namePassword]: string()
    .min(8, 'seed.firebase.authentication.form.newPassword.min')
    .required('seed.firebase.authentication.form.newPassword.required'),
  [namePasswordConfirmation]: string('')
    .oneOf([ref(`${namePassword}`), null], 'seed.firebase.authentication.form.newPasswordConfirmation.match')
    .required('seed.firebase.authentication.form.newPasswordConfirmation.required'),
});

const initialValues = {
  [nameOldPassword]: '',
  [namePassword]: '',
  [namePasswordConfirmation]: '',
};

const SeedFirebaseUpdatePasswordDialog = (props) => {
  const {
    open,
    onClose,
    isLoading,
    onSubmit,
    onSubmitWithPassword,
    icons,
    withPassword,
  } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <FormattedMessage id={withPassword ? 'seed.firebase.authentication.updatePassword.dialog.title' : 'seed.firebase.authentication.setPassword.dialog.title'} />
      </DialogTitle>
      <DialogContent>
        {
          withPassword ? null : (
            <>
              <Typography variant="subtitle2">
                <FormattedMessage id="seed.firebase.authentication.setPassword.dialog.subtitle" />
              </Typography>
              <Box mt={2} />
            </>
          )
        }
        <MyForm
          fields={withPassword ? withPasswordFields : fields}
          validationSchema={withPassword ? withPasswordValidationSchema : validationSchema}
          onSubmit={withPassword ? onSubmitWithPassword : onSubmit}
          disabled={isLoading}
          initialValues={initialValues}
          submitButtonLabelId={withPassword ? 'seed.firebase.authentication.updatePassword.button' : 'seed.firebase.authentication.setPassword.button'}
          icons={icons}
        />
      </DialogContent>
    </Dialog>
  );
};

SeedFirebaseUpdatePasswordDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onSubmitWithPassword: PropTypes.func.isRequired,
  icons: PropTypes.objectOf(PropTypes.object),
  withPassword: PropTypes.bool,
};

SeedFirebaseUpdatePasswordDialog.defaultProps = {
  isLoading: false,
  icons: seedAppIcons,
  withPassword: false,
};

export default SeedFirebaseUpdatePasswordDialog;
